<mat-dialog-content>
  <!-- NAME -->
  <div class="form-group">
    <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
      <mat-label>Nom de la catégorie</mat-label>
      <input
        matInput
        [maxlength]="titreMaxLen"
        [(ngModel)]="item.name"
        [disabled]="mode === 'view'"
      />
      <mat-hint align="end">
        <code>{{ item.name?.length || 0 }}</code> / <code>{{ titreMaxLen }}</code>
      </mat-hint>
    </mat-form-field>
  </div>

  <!-- DESCRIPTION -->
  <div class="form-group">
    <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
      <mat-label>Description</mat-label>
      <textarea
        matInput
        [maxlength]="descriptionMaxLen"
        [(ngModel)]="item.description"
        [disabled]="mode === 'view'"
        rows="3">
      </textarea>
      <mat-hint align="end">
        <code>{{ item.description?.length || 0 }}</code> / <code>{{ descriptionMaxLen }}</code>
      </mat-hint>
    </mat-form-field>
  </div>

  <!-- ACTIVE STATUS -->
  <div class="form-group">
    <mat-slide-toggle
      [(ngModel)]="item.active"
      [disabled]="mode === 'view'">
      Catégorie {{ item.active ? 'active' : 'inactive' }}
    </mat-slide-toggle>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="center">
  <button
    mat-button
    (click)="onCancel()">
    Fermer
  </button>
  <button
    mat-raised-button
    color="accent"
    (click)="onCloseClick()"
    *ngIf="mode !== 'view'"
    tabindex="1"
    data-cy="button-category-confirm">
    {{ confirmButtonText }}
  </button>
</mat-dialog-actions>
